import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Auth } from 'src/app/models/auth';
import { Fuels, Species, vehicleCreate } from 'src/app/models/vehicle';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { VehicleService } from 'src/app/services/vehicles.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';

@Component({
  selector: 'app-veiculos-create',
  templateUrl: './veiculos-create.component.html',
  styleUrls: ['./veiculos-create.component.css']
})
export class VeiculosCreateComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private alertService: NewAlertService,
    private vehicleService: VehicleService,
    private authenticationService: AuthenticationService,
  ) { }

  public get form() {
    return this.vehicleFormGroup.controls;
  }

  private currentUser: Auth;

  public vehicleFormGroup: FormGroup;
  public speciesList: Species[];
  public fuelsList: Fuels[];

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;

    this.loadLists();
    this.createForm();
  }

  loadLists() {
    this.vehicleService.getSpecies()
      .subscribe(response => {
        this.speciesList = response.result.filter(x => x.isActive);
      });
    this.vehicleService.getFuels()
      .subscribe(response => {
        this.fuelsList = response.result;
      });
  }

  createForm() {
    this.vehicleFormGroup = this.formBuilder.group({
      nickName: new FormControl(null, [
        Validators.required
      ]),
      registrationPlate: new FormControl(null, [
        Validators.required,
        Validators.pattern('^[a-zA-Z]{3}[0-9]{1}[a-zA-Z0-9]{1}[0-9]{2}$'),
        Validators.minLength(7),
        Validators.maxLength(7)
      ]),
      manufacturer: new FormControl(null, [
        Validators.required
      ]),
      model: new FormControl(null, [
        Validators.required
      ]),
      modelYear: new FormControl(null, [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(4)
      ]),
      manufactureYear: new FormControl(null, [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(4)
      ]),
      renavam: new FormControl(null, [
        Validators.required,
        Validators.maxLength(11)
      ]),
      fuelConsumption: new FormControl(null, [
        Validators.required
      ]),
      specieId: new FormControl(null, [
        Validators.required,
      ]),
      fuelId: new FormControl(null, [
        Validators.required,
      ]),
      transactionsPerDay: new FormControl(null, [
      ]),
      transactionMaxValue: new FormControl(null, [
      ]),
      transactionsMaxValuePerDay: new FormControl(null, [
      ]),
      startOdometer: new FormControl(null, [
      ])
    });
  }

  onSubmit(vehicleCreate: vehicleCreate) {
    if (this.vehicleFormGroup.valid) {
      this.vehicleService.createvehicle(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId, vehicleCreate)
        .subscribe(response => {
          if (response.status === ApiError.Sucesso) {
            this.alertService.success("Veículo cadastrado com sucesso!", true);

            this.router.navigate([`list`], { relativeTo: this.route.parent });
          } else {
            this.alertService.error("Falha ao cadastrar favorecido", true);
          }
        });
    } else {
      GenericValidator.verifierValidatorsForm(this.vehicleFormGroup);
    }
  }

  goToBack() {
    this.router.navigate(['portal/veiculos/list']);
  }
}
